import './tickets.less';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import cn from 'classname';
import { Link } from 'react-router';
import Search from '../../shared/search/main';

import get from 'lodash/get';
import isNull from 'lodash/isNull';
import find from 'lodash/find';
import flatten from 'lodash/flatten';

import Switch from './switch';
import LinkToThread from '../../shared/link';

const propTypes = {
	ticketsList: PropTypes.object,
	data: PropTypes.object,
	switchToTicket: PropTypes.func,
	pause: PropTypes.func,
	unpause: PropTypes.func,
	threadStatusesList: PropTypes.array,
	intl: PropTypes.func,
	search: PropTypes.func,
	can: PropTypes.func
};

class Requests extends React.Component {
	componentDidMount() {
		const { data: { id } } = this.props;
		const $wrap = this.refs['wrap'];
		const $activeTicket = this.refs[`ticket_${id}`];
		if ($activeTicket) {
			$wrap.scrollTop = $activeTicket.offsetTop - $activeTicket.offsetHeight;
		}
	}

	render() {
		const { ticketsList, intl } = this.props;

		return (
			<div className="thread-container">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<Link to="threads/" className="link">
							{intl('Return to list of threads')}
						</Link>
					</div>
				</div>

				<div className="support__tickets" ref="wrap">
					<span className="support__tickets--shadow" />
					<div className="support__tickets-search">
						<Search
							form="threadsItemSearchForm"
							action={this.props.search}
						/>
					</div>

					{ ticketsList.type === 'group' && ticketsList.rows.length && (
						getGroupedTicket(ticketsList.rows, this.props)
					)}

					{ ticketsList.type === 'list' && (
						ticketsList.rows.map(row => ticketItem(row, this.props))
					)}

				</div>
			</div>
		);
	}
}

const getRowStyle = (statusesList, row) => {
	let style = [];
	let rowStatus = row.status;
	style.push(get(find(statusesList, status => status.id === rowStatus), 'id'));

	let isWithoutAnswer =
		isNull(row.last_answer) ||
		(!isNull(row.last_answer) &&
		!isNull(row.last_affiliate_post) &&
		moment(row.last_answer.created_at).isBefore(row.last_affiliate_post.created_at));

	let isLongWithoutAnswer =
		isWithoutAnswer &&
		!isNull(row.last_affiliate_post) &&
		Math.abs(moment.duration(moment(row.last_affiliate_post.created_at).diff()).asHours()) > 1;

	if (isLongWithoutAnswer) {
		style.push('long-without-answer');
	} else if (isWithoutAnswer) {
		style.push('without-answer');
	}

	return style.join(' ');
};

// functions
const ticketItem = (row, props, className = '') => (
	<div className="support__tickets-group" key={row.date}>
		<p className="date">
			{moment(row.date).format('DD.MM.YYYY')}
		</p>
		{row.tickets.map(ticket =>
			<LinkToThread
				to={`threads/${ticket.id}`}
				requestQueryString={window.location.search.slice(1)}
				ref={`ticket_${ticket.id}`}
				className={cn({
					ticket: true,
					selected: props.data.id === ticket.id,
					paused: !!ticket.paused_at,
					[className]: className.length,
					[`${getRowStyle(props.threadStatusesList, ticket)}`]: true
				})}
				key={ticket.id}>
				<div className="ticket__header clearfix">
					<p className="email">
						{ticket.affiliate}
					</p>
					{ !ticket.closed_at && props.can('answer') && (
						<Switch
							isActive={!ticket.paused_at}
							onSwitch={e => {
								e && e.stopPropagation();
								return ticket.paused_at ? props.unpause(ticket.id) : props.pause(ticket.id);
							}} />
					) }
					<p className="time">
						{moment(ticket.updated_at).format('HH:mm')}
					</p>
				</div>
				<p className="theme">
					{ticket.title}
					{ticket.last_affiliate_post &&
					!ticket.closed_at &&
					!ticket.last_affiliate_post.viewed_at &&
					<span className="unread" />}
				</p>
			</LinkToThread>
		)}
	</div>
);

ticketItem.propTypes = {
	can: PropTypes.func
};

const getGroupedTicket = (rows, props) => {
	const res = [];

	rows.forEach((row, i) => {
		row.data.length && res.push(
			<div key={i} className={`group--${row.className}`}>
				<span className="title font-roboto-bold">{props.intl(row.name)}</span>
			</div>
		);

		res.push(
			flatten(
				row.data.map((entity, i) => ticketItem(entity, props, `row--${row.className}`))
			)
		);
	});

	return res;
};

Requests.propTypes = propTypes;
export default Requests;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/threads/components/tickets.js